import users from "../../features/users";
import organizations from "../../features/organizations";
import analysisGroups from "../../features/analysis-groups";
import dicomNodes from "../../features/dicom-nodes";
import activities from "../../features/activities";

export const ROLES = [undefined, "Admin", "Member", "SuperAdmin", "CROClinicalTrialProgramManager"]

export const adminResources = [
  {
    name: "users",
    props: users,
    resourcePermision: ["SuperAdmin", "Admin", "Member"],
    createPermission: ["SuperAdmin", "Admin"],
    listPermission: ["SuperAdmin", "Admin"],
    showPermission: [],
    editPermission: ["SuperAdmin", "Admin"], //TODO: need to refactor with adding user profile
  },
  {
    name: "organizations",
    props: organizations,
    resourcePermision: ["SuperAdmin", "Admin", "Member"],
    createPermission: ["SuperAdmin"],
    listPermission: ["SuperAdmin", "Admin"],
    showPermission: [],
    editPermission: ["SuperAdmin", "Admin"],
  },
  {
    name: "analyzis_groups",
    props: analysisGroups,
    resourcePermision: ["SuperAdmin", "Admin", "Member"],
    createPermission: ["SuperAdmin", "Admin"],
    listPermission: ["SuperAdmin", "Admin"],
    showPermission: [],
    editPermission: ["SuperAdmin", "Admin"],
  },
  {
    name: "dicom_nodes",
    props: dicomNodes,
    resourcePermision: ["SuperAdmin", "Admin", "Member"],
    createPermission: ["SuperAdmin", "Admin"],
    listPermission: ["SuperAdmin", "Admin"],
    showPermission: [],
    editPermission: ["SuperAdmin", "Admin"],
  },
  {
    name: "activity",
    props: activities,
    resourcePermision: ["SuperAdmin", "Admin"],
    createPermission: [],
    listPermission: ["SuperAdmin", "Admin"],
    showPermission: [],
    editPermission: [],
  },
];

export const actionPermissions = [
  undefined,
  {
    "/users": ["POST", "GET", "PUT", "DELETE"],
    "/activity": ["GET"],
    "/organizations": ["GET", "PUT"],
    "/analyzis_groups": ["POST", "GET", "PUT", "DELETE"],
    "/dicom_nodes": ["POST", "GET", "PUT", "DELETE"],
    "/dicom-web/stuides": ["POST", "GET", "PUT", "DELETE"],
    "/fhir/ResearchStudy": ["GET"],
  },
  {
    "/users": ["GET"],
    "/activity": [],
    "/organizations": ["GET"],
    "/analyzis_groups": ["GET"],
    "/dicom_nodes": ["GET"],
    "/dicom-web/stuides": ["POST", "GET", "PUT", "DELETE"],
    "/fhir/ResearchStudy": ["GET"],
  },
  {
    "/users": ["POST", "GET", "PUT", "DELETE"],
    "/activity": ["GET"],
    "/organizations": ["POST", "GET", "PUT", "DELETE"],
    "/analyzis_groups": ["POST", "GET", "PUT", "DELETE"],
    "/dicom_nodes": ["POST", "GET", "PUT", "DELETE"],
    "/dicom-web/stuides": ["POST", "GET", "PUT", "DELETE"],
    "/fhir/ResearchStudy": ["GET"],
  },
  {
    "/users": ["GET"],
    "/activity": [],
    "/organizations": [],
    "/analyzis_groups": [],
    "/dicom_nodes": [],
    "/dicom-web/stuides": [],
    "/fhir/ResearchStudy": ["GET"],
  }
]
